<template>
  <v-autocomplete
    v-model="tags"
    :disabled="loadingLinks"
    :items="links"
    chips
    color="blue-grey lighten-2"
    :label="labelDisplay"
    item-text="displayName"
    item-value="_id"
    multiple
    :loading="loadingLinks"
    dense
    outlined
  >
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        close
        @click="data.select"
        @click:close="remove(data.item)"
        v-if="data.item && data.item.displayName"
        :input-value="data.selected"
        @input="remove(data.item)"
      >
        <v-avatar>
          <v-img
            v-if="data.item"
            :src="
              userFile(
                data.item.userImageSmall
                  ? data.item.userImageSmall
                  : data.item.userImage,
                false
              )
            "
          ></v-img>
        </v-avatar>
        <span class="pl-1">{{ data.item.fName }}</span>
      </v-chip>
    </template>
    <template v-slot:item="data">
      <template>
          <v-list-item-avatar>
            <img
              v-if="data.item"
              :src="
                userFile(
                  data.item.userImageSmall
                    ? data.item.userImageSmall
                    : data.item.userImage,
                  false
                )
              "
            />
          </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            v-if="data.item"
            v-html="data.item.displayName"
          ></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>
<script>
import AcademyService from "@/services/AcademyService";

export default {
  data() {
    return {
      tags: null,
      search: null,
      links: null,
      linkIds: [],
      autoUpdate: true,
      labelDisplay: this.$t('message.tag_a_member'),
      loadingLinks: false,
    };
  },
  components: {},
  props: ["user", "value", "users", "label"],
  watch: {
    tags: {
      handler: function () {
        this.$emit("input", this.tags);
      },
    },
  },
  created() {
    if(this.label)
      this.labelDisplay = this.label;
    this.loadingLinks = true;
    if (this.$store.state.userManagedAcademy) {
      AcademyService.academyMembers(this.$store.state.userManagedAcademy)
        .then((data) => {
          if (data) {
            this.links = data.members;
            this.loadingLinks = false;
            for (const l of this.links) {
              if (l.displayName)
                this.linkIds.push(l._id)
            }
          }
        });
    }
  },
  methods: {
    remove(item) {
      const index = this.tags.indexOf(item._id);
      if (index >= 0) this.tags.splice(index, 1);
    },
    clearAll() {
      this.tags = [];
    },
  },
};
</script>
<style scoped>
</style>